import React, { Component } from 'react'
import PuzzleImage from "../../styles/images/white-monday-puzzle-image.jpg";
import { Button, InputGroup } from "@blueprintjs/core";
import { validate } from "validate.js";
import { Translate, I18n } from "react-redux-i18n";

class PuzzleAddressForm extends Component {
    state = {
        circle_form: {name:"",address:""},
        validation_errors: {}
    }

    updateFields=(event)=>{            
        this.setState({
            circle_form:{
                ...this.state.circle_form,
                [event.target.id]: event.target.value
            }
        }); 
        return true;
    }    

    submitForm=(e)=>{
        e.preventDefault();         
        const validationErrors = validate(
            this.state.circle_form,
            this.props.validators
        );

        this.setState({
          validation_errors: validationErrors ? validationErrors : {}
        });        

        if (!validationErrors || Object.keys(validationErrors).length===0) {
          this.props.sendOrder(this.state.circle_form);
        }
    }

    render() {
        return (
            <form onSubmit={this.submitForm} >
                <label htmlFor="name">
                    <strong><Translate value="whitemonday.puzzle_gift.form_header" /></strong>
                </label>
                <div className={
                    this.state.validation_errors.name
                    ? "form-group error"
                    : "form-group"
                    }
                >
                    <label htmlFor="name">
                        {this.state.validation_errors.name?
                            <Translate
                                value={this.state.validation_errors.name[0]}
                            />
                        : ''
                        }                                 
                    </label>
                    <InputGroup
                        leftIcon="person"
                        type="text"
                        placeholder={I18n.t('whitemonday.placeholders.name')}
                        fill={true}
                        id="name"
                        name="name"
                        value={this.state.circle_form.name}
                        onChange={this.updateFields}
                    />
                 </div>
                 <div className={
                    this.state.validation_errors.name
                    ? "form-group error"
                    : "form-group"
                    }
                >
                    <label htmlFor="name">
                        {this.state.validation_errors.address?
                            <Translate
                                value={this.state.validation_errors.address[0]}
                            />
                        : ''
                        }                                 
                    </label>
                    <InputGroup
                        leftIcon="map-marker"
                        type="text"
                        placeholder={I18n.t('whitemonday.placeholders.address')}
                        fill={true}
                        id="address"
                        name="address"
                        value={this.state.circle_form.address}
                        onChange={this.updateFields}
                    />
                </div>

                <div className="form-copy-text">
                    <p><Translate value="whitemonday.puzzle_gift.form_p1" /></p>
                    <p>
                        <Translate value="whitemonday.puzzle_gift.form_p2_1" /><br />
                        <Translate value="whitemonday.puzzle_gift.form_p2_2" /><br />
                    </p>
                    <p><Translate value="whitemonday.puzzle_gift.form_p3" /></p>
                    <p>
                        <Translate value="whitemonday.puzzle_gift.form_p4_1" />
                        <a href="mailto:info@ihopa.com" target="_blank" rel="noopener noreferrer">
                            <strong><Translate value="whitemonday.puzzle_gift.form_p4_2" /></strong>
                        </a>.
                    </p>
                </div>

                <div className="puzzle-image">
                    <img src={PuzzleImage} alt="ihopa puzzle" />
                </div>
                <Button
                    loading={this.props.loading}
                    disabled={this.props.loading}
                    intent="primary"
                    fill={true}
                    type="submit"
                >
                    <Translate value="whitemonday.puzzle_gift.send_order" />                    
                </Button>
            </form>
        )
    }
}
export default PuzzleAddressForm;